import { ApiError } from '../api/client'
import { UNSUPPORTED_UPLOAD_MESSAGE } from './upload-accept'

/** Pull an HTTP status off whatever an upload rejection surfaced. */
export function extractUploadErrorStatus(error: unknown): number | null {
  if (error instanceof ApiError) return error.status
  if (
    error !== null &&
    typeof error === 'object' &&
    'status' in error &&
    typeof (error as { status: unknown }).status === 'number'
  ) {
    return (error as { status: number }).status
  }
  return null
}

/**
 * Map an upload rejection to a short, user-facing reason.
 *
 * The api raises document errors as FastAPI `HTTPException` (`{detail: ...}`),
 * which the client can't unwrap into its `{error}` envelope, so a raw rejection
 * reads "Request failed with status 415". This maps the status codes the upload
 * route actually returns to friendly copy instead. Shared by the apply-flow
 * staged-file chips and the leave-detail DocumentChips widget so both read the
 * same.
 */
export function uploadErrorMessage(error: unknown): string {
  const status = extractUploadErrorStatus(error)
  if (status === 413) return 'File too large. Max 5 MB.'
  if (status === 415) return UNSUPPORTED_UPLOAD_MESSAGE
  if (status === 503 || status === 502)
    return 'Document storage is unavailable. Try again later.'
  return 'Upload failed. Please try again.'
}
